<template>
	<font>
		<!-- 国旗图标 -->
		<i :class="'fi fi-' + country.toLowerCase()"> </i>
		<el-tag style="margin-left: 5px;" v-if="asinInfo.primeTry" effect="plain" size="mini">Prime </el-tag>
		<!-- Amazon's标记 -->
		<el-tag style="margin-left: 5px;" v-if="asinInfo.ac" type="info" effect="plain" size="mini">AC</el-tag>
		<!-- bast seller标记 -->
		<el-tag style="margin-left: 5px;" v-if="asinInfo.bs" type="warning" effect="plain" size="mini">BS</el-tag>
		<!-- A-plus 标记 -->
		<el-tag style="margin-left: 5px;" v-if="asinInfo.aPlus === 1" type="success" effect="plain" size="mini">A+</el-tag>
	</font>
</template>

<script>
export default {
	name: 'badgeSub',
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg'],
	props:{
		asinInfo : {
			required:true
		},
		country : {
			default : 'us',
		}
	},
	data() {
		return {
		
		}
	},
	methods: {
	},
	watch: {}
}
</script>

<style>
</style>
